import { createStore, combineReducers, compose } from "redux";
import { reactReduxFirebase, firebaseReducer } from "react-redux-firebase";

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAmXjpWoOIZYtp1ygiTzWkbxKpCmGXj4ng",
  authDomain: "hot-tip.accodeing.app",
  databaseURL: "https://stock-tec.firebaseio.com",
  projectId: "stock-tec",
  storageBucket: "stock-tec.appspot.com",
  messagingSenderId: "691593359308"
};

// react-redux-firebase config
const rrfConfig = {
  userProfile: "users"
  // useFirestoreForProfile: true // Firestore for Profile instead of Realtime DB
};

// Initialize firebase instance
firebase.initializeApp(firebaseConfig);

// Add reactReduxFirebase enhancer when making store creator
const createStoreWithFirebase = compose(
  reactReduxFirebase(firebase, rrfConfig) // firebase instance as first argument
)(createStore);

// Add firebase to reducers
const rootReducer = combineReducers({
  firebase: firebaseReducer
});

// Create store with reducers and initial state
const initialState = {};
export default createStoreWithFirebase(rootReducer, initialState);



// WEBPACK FOOTER //
// ./src/redux.js